<template>
    <main class="product flex" :class="{'body': !isAllowedPrint}">
        <div class="sidebar">
            <router-link class="back flex flex-align" :to="{name: 'library'}">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z"/>
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <line x1="5" y1="12" x2="11" y2="18" />
                    <line x1="5" y1="12" x2="11" y2="6" />
                </svg>
                Back to Library
            </router-link>
            <nav v-if="variation">
                <div class="snapshot" v-if="variation.product.metadata.toc">
                    <h3>Overview</h3>
                    <div class="unit flex oh">
                        <router-link :to="{name: 'product.contents'}" class="unit-title block text-overflow">Table of Contents</router-link>
                    </div>
                </div>
                <div class="snapshot" v-for="snapshot of snapshots" :key="snapshot.id">
                    <h3>{{snapshot.title}}</h3>
                    <div class="unit flex oh" v-for="unit of snapshot.units" :key="unit.id">
                        <router-link :to="{name: 'product.units.unit', params: {unit: unit.id}}" class="unit-title block text-overflow">{{unit.title}}</router-link>
                    </div>
                </div>
            </nav>
        </div>
        <div class="layout ff">
            <router-view :unit="unit" :contents="contents" :snapshots="snapshots" />
        </div>
    </main>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'Product',
        data(){
            return {
                units: {}
            }
        },
        watch: {
            '$route.params.product': {
                immediate: true,
                handler(){
                    if(this.$route.params.product){
                        //Activate the product in Vuex.
                        this.$store.dispatch('products/activate', this.$route.params.product)

                        //Load the product snapshots from the server.
                        .then(() => this.$store.dispatch('products/snapshots', this.$route.params.product))

                        //Load the product contents.
                        .then(() => this.$store.dispatch('products/contents', this.$route.params.product))

                        //Select one to focus.
                        .then(() => {
                            console.log('got contents');
                            for(const snapshot of this.snapshots){
                                for(const unit of snapshot.units){
                                    Vue.set(this.units, unit.id, unit);
                                }
                            }

                            console.log('set units', this.$route.name);
                            if(this.$route.name === 'product.units'){
                                const snapshot = this.snapshots[0];

                                console.log('snapshot?', snapshot);
                                if(snapshot){
                                    const unit = snapshot.units[0];

                                    console.log(this.variation.product.metadata.toc, snapshot.units.length);
                                    if(this.variation.product.metadata.toc){
                                        return this.$router.push({name: 'product.contents'});
                                    }

                                    if(unit){
                                        return this.$router.push({name: 'product.units.unit', params: {unit: unit.id}});
                                    }
                                }
                            }
                        })
                        .catch(error => {
                            this.$toasted.error('There was an error loading this product.');
                        });
                    }
                }
            }
        },
        computed: {
            variation(){
                return this.$store.getters.product;
            },
            user(){
                return this.$store.state.user;
            },
            unit(){
                return this.units[this.$route.params.unit];
            },
            contents(){
                return this.variation.contents;
            },
            snapshots(){
                return this.variation.snapshots;
            },
            isAllowedPrint() {
                const allowPrinting = localStorage.getItem('allow_package_printing') ? true : null;
                return (allowPrinting !== null) ? true : false;
            }
        }
    }
    
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .product
    {
        width: 100vw;
        min-height: 100vh;
        align-items: stretch;
    }

    .back
    {
        font-size: 16px;
        font-weight: 500;
        padding-left: 50px;
        color: @base;
        height: 40px;
        padding: 10px 0;

        .icon
        {
            width: 20px;
            height: 20px;
            display: inline-block;
            margin-right: 10px;
        }
    }

    .sidebar
    {
        padding: 40px;
        flex: 0.3;
        background: @f8;
        overflow: hidden;
        min-width: 375px;
    }

    .layout
    {
        padding: 50px 100px;

        &.loading
        {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .snapshot
    {
        margin-top: 30px;
        border-top: 1px solid @e4;

        h3
        {
            font-size: 18px;
            line-height: 26px;
            padding-right: 20px;
            margin: 30px 0 15px;
        }

        .unit
        {
            font-size: 15px;
            font-weight: 400;
            height: 26px;
            line-height: 26px;
            margin: 10px 0;
        }

        .unit-title
        {
            cursor: pointer;
            color: @grey;
            transition: color ease 0.25s;

            &::after
            {
                content: "";
                position: absolute;
                border-bottom: 1px solid @grey;
                top: 0;
                left: 0;
                bottom: 0px;
                pointer-events: none;
                width: 0;
                transition: width ease 0.25s, color ease 0.25s;
                opacity: 0.6;
            }

            &:hover, &:active
            {
                &::after
                {
                    width: 100%;
                }
            }

            &.router-link-exact-active
            {
                color: @base;

                &::after
                {
                    width: 100%;
                    opacity: 0.8;
                    border-bottom-color: @base;
                }
            }
        }
    }
    @media print {
        .body * {
            visibility: hidden;
        }

        .body:after {
            content: "Printing is disabled.";
            visibility: visible;
            display: block;
            text-align: center;
            font-size: 20px;
            margin-top: 50vh;
            transform: translateY(-50%);
        }
        .layout {
            padding: 0 !important;
        }
        .sidebar {
            display: none !important;
        }
        .pdf {
            width: 100% !important;
        }
        .page {
            width: 100% !important;
        }
  

    }
</style>